import { useMemo, useEffect } from 'react'
import { Box, Button, Container, Grid, Typography, Paper } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useLanguage } from '../contexts/LanguageContext'
import PublicHeader from '../components/public/PublicHeader'

// Wszystkie dostępne obrazy mężczyzn (man-1.jpg do man-6.jpg)
const MAN_IMAGES = [
  '/images-for-project/man/man-1.jpg',
  '/images-for-project/man/man-2.jpg',
  '/images-for-project/man/man-3.jpg',
  '/images-for-project/man/man-4.jpg',
  '/images-for-project/man/man-5.jpg',
  '/images-for-project/man/man-6.jpg',
]

// Wszystkie dostępne obrazy kobiet (woman-1.jpg do woman-10.jpg)
const WOMAN_IMAGES = [
  '/images-for-project/woman/woman-1.jpg',
  '/images-for-project/woman/woman-2.jpg',
  '/images-for-project/woman/woman-3.jpg',
  '/images-for-project/woman/woman-4.jpg',
  '/images-for-project/woman/woman-5.jpg',
  '/images-for-project/woman/woman-6.jpg',
  '/images-for-project/woman/woman-7.jpg',
  '/images-for-project/woman/woman-8.jpg',
  '/images-for-project/woman/woman-9.jpg',
  '/images-for-project/woman/woman-10.jpg',
]

const pickRandom = (arr: string[]) => arr[Math.floor(Math.random() * arr.length)]

const HomePage = () => {
  const manSrc = useMemo(() => pickRandom(MAN_IMAGES), [])
  const womanSrc = useMemo(() => pickRandom(WOMAN_IMAGES), [])
  const navigate = useNavigate()
  const { t } = useLanguage()

  // Scroll to #product anchor on direct link (/#product) after initial render
  useEffect(() => {
    if (window.location.hash === '#product') {
      const el = document.getElementById('product')
      if (el) {
        // Defer to ensure layout is ready
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 0)
      }
    }
  }, [])

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#fafafa' }}>
      <PublicHeader />

      <Container maxWidth="xl" sx={{ mt: 6, mb: 8 }}>
        <Grid container spacing={3} alignItems="stretch">
          <Grid item xs={12} md={4}>
            <Paper elevation={3} sx={{ borderRadius: 3, overflow: 'hidden', height: '100%' }}>
              <Box sx={{ position: 'relative', pt: '120%', width: '100%' }}>
                <img src={manSrc} alt="Model - man" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover' }} />
              </Box>
            </Paper>
          </Grid>

          <Grid item xs={12} md={4}>
            <Paper elevation={0} sx={{ borderRadius: 3, height: '100%', p: { xs: 3, md: 4 }, display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center', background: 'transparent' }}>
              <Typography variant="h3" sx={{ fontWeight: 800, letterSpacing: '-0.02em', mb: 1 }}>
                {t('home.tagline', 'Your clothes. Your models. YourModel.eu')}
              </Typography>
              <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 3 }}>
                {t('home.short', 'YourModel.eu tworzy realistyczne zdjęcia modelek — wirtualnych lub prawdziwych — prezentujących odzież i akcesoria marek modowych: buty, torebki, okulary i więcej.')}
              </Typography>
              <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
                <Button variant="contained" size="large" onClick={() => navigate('/login')} sx={{ borderRadius: 2 }}>
                  {t('nav.login', 'Login')}
                </Button>
                <Button variant="outlined" size="large" onClick={() => navigate('/register')} sx={{ borderRadius: 2 }}>
                  {t('nav.register', 'Rejestracja')}
                </Button>
              </Box>
            </Paper>
          </Grid>

          <Grid item xs={12} md={4}>
            <Paper elevation={3} sx={{ borderRadius: 3, overflow: 'hidden', height: '100%' }}>
              <Box sx={{ position: 'relative', pt: '120%', width: '100%' }}>
                <img src={womanSrc} alt="Model - woman" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover' }} />
              </Box>
            </Paper>
          </Grid>
        </Grid>

        <Box id="product" sx={{ mt: 8 }}>
          <Typography variant="h4" sx={{ fontWeight: 700, mb: 2 }}>
            {t('nav.product', 'Opis produktu')}
          </Typography>
          <Typography variant="body1" sx={{ mb: 1.5 }}>{t('home.full.1')}</Typography>
          <Typography variant="body1" sx={{ mb: 1.5 }}>{t('home.full.2')}</Typography>
          <Typography variant="body1" sx={{ mb: 1.5 }}>{t('home.full.3')}</Typography>
          <Typography variant="body1" sx={{ mb: 1.5 }}>{t('home.full.4')}</Typography>
        </Box>
      </Container>
    </Box>
  )
}

export default HomePage
